/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export type ReportsFindCoordinatesWildTypeItem =
  (typeof ReportsFindCoordinatesWildTypeItem)[keyof typeof ReportsFindCoordinatesWildTypeItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindCoordinatesWildTypeItem = {
  freeRoaming: 'freeRoaming',
  captive: 'captive',
  feral: 'feral',
} as const;
